import type { ReactNode } from "react";

interface DetailPanelProps {
  readonly id?: string;
  readonly title: string;
  readonly children: ReactNode;
}

export function DetailPanel({ id, title, children }: DetailPanelProps) {
  return (
    <section className="admin-panel detail-panel" id={id}>
      <h2>{title}</h2>
      <div>{children}</div>
    </section>
  );
}
